import script from "./UMap.vue?vue&type=script&setup=true&lang=ts"
export * from "./UMap.vue?vue&type=script&setup=true&lang=ts"

import "./UMap.vue?vue&type=style&index=0&id=9b3a4190&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b3a4190"]])

export default __exports__